// extracted by mini-css-extract-plugin
export default {"container":"wR-z","topReviewHeading":"xR-z","criticalReview":"yR-z","favorableReview":"zR-z","vsSeparator":"AR-z"};